import { DvGridComponent, DvToolbarAction } from '@devinco/ui/grid';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { GridOptions } from '@features/vt-grid/interfaces/grid-options';
import { RouteNetworksGridService } from './route-networks-grid.service';
import { GridOptionsService } from '@features/vt-grid/grid-options/grid-options.service';
import { Entity } from '@shared/constants/entity';
import { AgGridModule } from 'ag-grid-angular';
import { DirectivesModule } from '@shared/directives/directives.module';

@Component({
  selector: 'app-route-networks-grid',
  imports: [AgGridModule, DvGridComponent, DirectivesModule],
  templateUrl: './route-networks-grid.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [GridOptionsService],
})
export class RouteNetworksGridComponent {
  private gridService = inject(RouteNetworksGridService);
  private gridOptionsService = inject(GridOptionsService);
  gridOptions: GridOptions;
  actions: DvToolbarAction[];

  constructor() {
    this.gridOptions = this.gridOptionsService.clientSide(
      this.gridService.getColDefs(),
      Entity.RouteNetworkWeb
    );
    this.actions = this.gridService.getToolbarActions();
  }
}
